import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import type { FC, ReactNode } from 'react';
import type { AgentIntroSourceType } from '@/pages/AgentIntro/components/TrainingSourceSelector/TrainingSourceSelector.type';
import { cn } from '@/utils';

type ToggleButtonProps = {
	active: boolean;
	label: string;
	onClick: (tab: AgentIntroSourceType) => void;
	tab: AgentIntroSourceType;
	icon?: ReactNode;
};

const IntroToggleButton: FC<ToggleButtonProps> = ({
	active,
	label,
	onClick,
	tab,
	icon
}) => (
	<motion.button
		className={cn(
			'flex h-[36px] w-full cursor-pointer items-center justify-center gap-1.5 overflow-hidden rounded-lg',
			'[font-family:var(--font-body)] text-xs border-none',
			'text-gray-500 opacity-50 bg-transparent',
			{
				'text-primary-900 opacity-100 px-2.5': active
			}
		)}
		layout={false}
		onClick={() => onClick(tab)}
		type="button"
	>
		<span className="flex h-[15px] w-[15px] items-center justify-center">
			{icon ?? (
				<Check
					className={cn(
						'h-[15px] w-[15px] transition-opacity',
						active ? 'opacity-100' : 'opacity-0'
					)}
				/>
			)}
		</span>

		<span className="whitespace-nowrap">{label}</span>
	</motion.button>
);

export default IntroToggleButton;
